module.exports = __webpack_public_path__ + "static/media/room-14.f889a225.jpg";